export enum LogLevel {
  ERROR = "error",
  WARNING = "warning",
}

export abstract class AggregationError extends Error {
  aggregatorError?: string;
  chemicalId?: string;
  chemicalName?: string;
  logLevel: LogLevel;
  /**
   * Set logLevel to LogLevel.WARNING to log as a warning instead of an error.
   */
  constructor(message: string, logLevel: LogLevel = LogLevel.ERROR) {
    super(message);
    this.name = this.constructor.name;
    this.logLevel = logLevel;
  }
}

export class MissingDensity extends AggregationError {
  constructor(sourceUnit: string, targetUnit: string, chemicalId?: string, chemicalName?: string) {
    super("Conversions between mass and volume require a density.");
    // create the RFC record for these chemicals
    this.logLevel = LogLevel.WARNING;
    if (chemicalId) {
      this.chemicalId = chemicalId;
      this.aggregatorError = `We were unable to aggregate this chemical because we cannot convert ${sourceUnit} to ${targetUnit} for chemical: ${chemicalName} without a density.`;
    } else {
      this.aggregatorError = `We were unable to aggregate this chemical because we cannot convert ${sourceUnit} to ${targetUnit} without a density.`;
    }
  }
}

export class UnsupportedUnitConversion extends AggregationError {
  constructor(sourceUnit: string, targetUnit: string, chemicalId?: string, chemicalName?: string) {
    super(`Conversions from ${sourceUnit} to ${targetUnit} are currently not supported.`);
    if (chemicalId) {
      this.chemicalId = chemicalId;
      this.aggregatorError = `We were unable to aggregate this chemical because we cannot accurately convert ${sourceUnit} to ${targetUnit} at this time for chemical: ${chemicalName}.`;
    } else {
      // this.chemicalId = chemicalId ? chemicalId : null;
      // create the RFC record for these chemicals
      this.aggregatorError = `We were unable to aggregate this chemical because we cannot accurately convert ${sourceUnit} to ${targetUnit} at this time.`;
    }
  }
}

export class CouldNotDetermineUnit extends AggregationError {
  constructor(missingUnit: "from" | "to") {
    super(`Unable to determine ${missingUnit}Unit`);
    this.logLevel = LogLevel.WARNING;
    this.aggregatorError = `We were unable to aggregate this chemical because we cannot determine the unit to convert ${missingUnit}.`;
  }
}
